import { apiGet, apiSend } from './client';
import { isMockMode, type Environment } from '../constants';
import type { DashboardState } from '../dashboard/spec';

export interface Preferences {
  dashboard: DashboardState | null;
  updated_at: string;
}

const MOCK_KEY = 'nexus-ui.preferences.mock';

const readMock = (): Preferences | null => {
  try {
    const raw = globalThis.localStorage?.getItem(MOCK_KEY);
    return raw ? (JSON.parse(raw) as Preferences) : null;
  } catch {
    return null;
  }
};

const writeMock = (dashboard: DashboardState): Preferences => {
  const record = { dashboard, updated_at: new Date().toISOString() };
  try {
    globalThis.localStorage?.setItem(MOCK_KEY, JSON.stringify(record));
  } catch {
    // storage unavailable
  }
  return record;
};

/** Preferences are per staff member, not per environment, so they always go to the first configured API. */
export const getPreferences = async (environment: Environment): Promise<Preferences | null> => {
  if (isMockMode()) {
    return readMock();
  }
  const { data } = await apiGet<{ data: Preferences | null }>(environment, '/me/preferences');
  return data;
};

export const putPreferences = async (
  environment: Environment,
  dashboard: DashboardState,
): Promise<Preferences> => {
  if (isMockMode()) {
    return writeMock(dashboard);
  }
  const { data } = await apiSend<{ data: Preferences }>(environment, '/me/preferences', 'PUT', {
    dashboard,
  });
  return data;
};
